module.exports = __webpack_public_path__ + "img/s2Model2.1ca3859d.png";